import { connect } from 'react-redux'

import { loadData } from './reducer'

const mapStateToProps = (state) => {
    return {
        loading: state?.pages?.hall?.seating?.loading ?? false,
        data: state?.pages?.hall?.seating?.data ?? null,
        error: state?.pages?.hall?.seating?.error ?? null,
        selectedSeats: state?.pages?.hall?.movie?.selectedSeats ?? [],
    }
}

const hocConnect = (InnerComponent) => connect(mapStateToProps, { loadData })(InnerComponent)

export default hocConnect
